module.exports = __webpack_public_path__ + "static/media/smares_bg@2x.a9a7d36d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/smares_bg@2x.jpg
// module id = 154
// module chunks = 0